<template>
  <v-layout row wrap align-start align-content-start class="mb-2">
    <!-- Title and Actions -->
    <v-flex xs12 class="py-0">
      <v-toolbar tabs color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">code</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.label.CONFIG_SERVICE }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="showAddConfiguration">
          <v-icon left>add_circle</v-icon>
          <span>{{ messages.label.ADD_CONFIGURATION }}</span>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-layout>
      <!-- Key value List -->
      <v-flex xs6>
        <ConfigList />
      </v-flex>
      <!-- Key value Sheet -->
      <v-flex xs6 class="side-sheet-container mr-2">
        <ConfigDetails />
      </v-flex>
    </v-layout>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">
          {{ messages.label.OK }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapMutations } from "vuex"
import ConfigDetails from "@/ConfigService/ConfigDetails"
import ConfigList from "@/ConfigService/ConfigList"
import messages from "@/ConfigService/messages.json"
import {
  SET_CONFIG_DETAILS_SIDE_SHEET,
  SET_IS_EDIT_MODE,
  SET_SELECTED_KEY,
  SET_CONFIG_ERROR
} from "@/store/constants/mutation-types"

/**
 * initialData
 */
function initialData() {
  return {
    snackbar: {
      show: false,
      timeout: 6000,
      message: "",
      color: ""
    }
  }
}

export default {
  name: "ConfigServiceHome",
  components: {
    ConfigDetails,
    ConfigList
  },
  data: function () {
    return initialData(this)
  },
  methods: {

    ...mapMutations("configService", [
      SET_CONFIG_DETAILS_SIDE_SHEET,
      SET_IS_EDIT_MODE,
      SET_SELECTED_KEY,
      SET_CONFIG_ERROR
    ]),

    /**
     * reset data
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * Display side sheet to add a new configuration
     */
    showAddConfiguration() {
      this.SET_CONFIG_DETAILS_SIDE_SHEET(true)
      this.SET_IS_EDIT_MODE(false)
      this.SET_SELECTED_KEY({})
      this.SET_CONFIG_ERROR({
        status: "",
        message: ""
      })
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
  },
  beforeDestroy() { }
}
</script>

<style lang="scss">
.side-sheet-container {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/ConfigService/ConfigServiceHome.vue